var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "nativewind/jsx-runtime";
import EmptyViewText from '@/components/empty/EmptyViewText';
import { ScreenLayout } from '@/components/ScreenLayout';
import TabBar from '@/components/TabBar';
import useAppComponents from '@/hooks/useAppComponents';
import { FlashList } from '@shopify/flash-list';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { View } from 'react-native';
import { tabItems } from '../ReviewHistoryScreen/constants';
import ReviewUpvoteItem from './components/ReviewUpvoteItem';
export default function ReviewUpVoteScreen() {
    var _a;
    const { api } = useAppComponents();
    const [currentTab, setCurrentTab] = useState('PLACE_REVIEW');
    const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery({
        queryKey: ['ReviewsUpvoted', currentTab],
        queryFn: (_a) => __awaiter(this, [_a], void 0, function* ({ pageParam }) {
            if (currentTab === 'PLACE_REVIEW') {
                return (yield api.listUpvotedPlaceReviewsPost({
                    nextToken: pageParam,
                    limit: 20,
                })).data;
            }
            else {
                return (yield api.listUpvotedToiletReviewsPost({
                    nextToken: pageParam,
                    limit: 20,
                })).data;
            }
        }),
        getNextPageParam: lastPage => {
            return lastPage.nextToken;
        },
        initialPageParam: undefined,
    });
    return (_jsxs(ScreenLayout, { isHeaderVisible: true, children: [_jsx(TabBar, { items: tabItems, current: currentTab, onChange: setCurrentTab }), _jsx(FlashList, { data: (_a = data === null || data === void 0 ? void 0 : data.pages.flatMap(page => {
                    if (currentTab === 'PLACE_REVIEW') {
                        return page.placeReviews;
                    }
                    else {
                        return page.toiletReviews;
                    }
                })) !== null && _a !== void 0 ? _a : [], renderItem: ({ item }) => (_jsxs(_Fragment, { children: [_jsx(View, { className: "p-5", children: _jsx(ReviewUpvoteItem, { item: item }) }), _jsx(View, { className: "h-[1px] bg-gray-20" })] })), onEndReached: () => {
                    if (hasNextPage && !isFetchingNextPage) {
                        fetchNextPage();
                    }
                }, onEndReachedThreshold: 0.5, ListEmptyComponent: _jsx(EmptyViewText, {}), ListFooterComponent: _jsx(View, { className: "pb-[100px]" }) })] }));
}
